import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {Typography} from 'antd'
import classNames from 'classnames'
import {observer} from 'mobx-react'

import {Alert} from '@/components'
import {useScreenType} from '@/hooks'

import DirectDebitLogo from '~/assets/img/bank-accounts/direct-debit.svg'

import {CreateBankAccountStep} from '@/stores/bank-account-create/models'
import {StepsDescription} from '@/pages/BankAccountCreate/components'

import {AlertSectionProps} from './props'
import styles from './AlertSection.scss'

export const AlertSection = observer(({step, isValidationPassed}: AlertSectionProps) => {
    const { t } = useTranslation()
    const {isMobile} = useScreenType()

    switch (step) {
        case CreateBankAccountStep.initialForm:
            return (
                <>
                    {!isValidationPassed ? (
                        <Alert type='warning' description={t('BankAccountCreate.alerts.validation.checkDetails')} />
                    ) : (
                        <div className={styles.emptyBlock} />
                    )}
                    <Alert
                        type='info'
                        description={<div>{t('BankAccountCreate.infoTop.description')}</div>}
                        extra={
                            <img
                                src={DirectDebitLogo}
                                alt='Direct debit'
                                className={classNames(styles.alertImage, {
                                    [styles.alertImageMobile]: isMobile
                                })}
                            />
                        }
                    />
                </>
            )

        case CreateBankAccountStep.failure:
            return (
                <>
                    <Typography.Title level={4}>{t('BankAccountCreate.alerts.verification.results')}</Typography.Title>
                    <Alert
                        type='warning'
                        title={t('BankAccountCreate.alerts.verification.failed.title')}
                        description={<Trans i18nKey='BankAccountCreate.alerts.verification.failed.description' components={{br: <br />}} />}
                    />
                </>
            )

        case CreateBankAccountStep.success:
            return (
                <>
                    <Typography.Title level={4}>{t('BankAccountCreate.alerts.verification.title')}</Typography.Title>
                    <Alert
                        type='success'
                        title={t('BankAccountCreate.alerts.verification.success.title')}
                        description={t('BankAccountCreate.alerts.verification.success.description')}
                    />
                    <Typography.Title level={4}>{t('BankAccountCreate.alerts.nextSteps.title')}</Typography.Title>
                    <Alert
                        type='default'
                        title={t('BankAccountCreate.alerts.nextSteps.changeAccount.title')}
                        description={<StepsDescription />}
                    />
                </>
            )

        default:
            return null
    }
})
